export default __webpack_public_path__ + "static/media/pigeanpea.e5c65ac5.png";